import type {DataLayout, GridSection, PlaceholderBlock} from 'analysis-tool/data-layout/DataLayoutTypes';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import type {CreateStepParams} from 'pipelines/network/PipelineDAO';
import {getLatestStepVersion} from 'pipelines/StepConnectionUtils';
import type {JSONValue} from 'util/Types';

export const DEFAULT_LAYOUT_ROWS = 2;
export const DEFAULT_LAYOUT_COLUMNS = 2;

const PLACEHOLDER_BLOCK: PlaceholderBlock = {type: 'PLACEHOLDER'};

type DefaultGridSection = Omit<GridSection, 'rows'> & {rows: Array<Array<PlaceholderBlock>>};

interface DefaultLayoutConfig {
  name: DataLayout['name'];
  sections: Array<DefaultGridSection>;
}

export const DEFAULT_LAYOUT_CONFIG: DefaultLayoutConfig = {
  name: '[New Layout]',
  sections: [
    {
      type: 'GRID',
      title: null,
      gridMode: 'SEPARATED',
      rows: Array(DEFAULT_LAYOUT_ROWS)
        .fill(null)
        .map(() =>
          Array(DEFAULT_LAYOUT_COLUMNS)
            .fill(null)
            .map(() => PLACEHOLDER_BLOCK)
        ),
    },
  ],
};

export function getNewLayoutStepParams(): CreateStepParams {
  return {
    stepType: PipelineStepType.LAYOUT,
    stepVersion: getLatestStepVersion(PipelineStepType.LAYOUT),
    config: DEFAULT_LAYOUT_CONFIG as unknown as Record<string, JSONValue>,
    runAfterCreate: true,
  };
}
